export type ProductSlug =
  | 'private-backend'
  | 'private-frontend'
  | 'private-sd'
  | 'private-smp';

export type ProductDetail = {
  slug: ProductSlug;
  title: string;
  tagline: string;
  learnList: string[];
  outcomeList: string[];
  pricing: {
    promoMonthOnly: 1;
    basePriceValue: number;
    promoPriceValue: number;
    packages: Array<{
      id: 'PKG_4' | 'PKG_8';
      sessions: number;
      label: string;
      default?: boolean;
      required?: boolean;
    }>;
    note: string;
  };
  links: {
    checkoutBasePath: string;
    waLink: string;
    preMeetingLink: string;
  };
};

export const PRIVATE_CLASS_DETAILS: ProductDetail[] = [
  {
    slug: 'private-backend',
    title: 'Private Backend (BE)',
    tagline: 'Belajar backend terstruktur sampai siap bikin API.',
    learnList: ['Golang', 'PostgreSQL (SQL)', 'Redis (cache / key-value)', 'Docker', 'Git'],
    outcomeList: [
      'Mampu membangun REST API (CRUD) yang rapi dan konsisten',
      'Mampu menggunakan PostgreSQL untuk simpan & ambil data (query dasar)',
      'Mengenal Redis untuk caching/session sederhana',
      'Mampu menjalankan aplikasi via Docker (basic dockerize)',
      'Mampu kerja dengan Git workflow (branching & commit rapi)',
    ],
    pricing: {
      promoMonthOnly: 1,
      basePriceValue: 350000,
      promoPriceValue: 200000,
      packages: [
        { id: 'PKG_8', sessions: 8, label: 'Paket 8 Sesi', default: true, required: true },
      ],
      note: 'Diskon hanya berlaku selama bulan Januari dan khusus pembelian paket.',
    },
    links: {
      checkoutBasePath: '/checkout',
      waLink: 'WHATSAPP_LINK_BACKEND',
      preMeetingLink: '/book/premeeting?product=PRIVATE_BE',
    },
  },
  {
    slug: 'private-frontend',
    title: 'Private Frontend (FE)',
    tagline: 'Belajar frontend sampai bisa bikin React app siap demo.',
    learnList: [
      'HTML',
      'CSS',
      'JavaScript',
      'TypeScript',
      'React',
      'Tailwind CSS',
      'Axios',
      'Redux',
      'Git',
    ],
    outcomeList: [
      'Mampu membangun React app dari nol sampai siap demo',
      'Mampu membuat UI responsive dengan Tailwind',
      'Mampu integrasi API menggunakan Axios (loading/error state)',
      'Mampu mengelola state dasar menggunakan Redux',
      'Mampu kerja dengan Git workflow (branching & commit rapi)',
    ],
    pricing: {
      promoMonthOnly: 1,
      basePriceValue: 350000,
      promoPriceValue: 200000,
      packages: [
        { id: 'PKG_8', sessions: 8, label: 'Paket 8 Sesi', default: true, required: true },
      ],
      note: 'Diskon hanya berlaku selama bulan Januari dan khusus pembelian paket.',
    },
    links: {
      checkoutBasePath: '/checkout',
      waLink: 'WHATSAPP_LINK_FRONTEND',
      preMeetingLink: '/book/premeeting?product=PRIVATE_FE',
    },
  },
  {
    slug: 'private-sd',
    title: 'Private Anak SD',
    tagline: 'Belajar logika coding + web basic yang fun untuk anak SD.',
    learnList: ['Block-based coding', 'Block code HTML (web basic untuk anak)'],
    outcomeList: [
      'Paham logika dasar: urutan instruksi, pengulangan, kondisi',
      'Bisa membuat mini project (game/animasi sederhana) dengan block-based coding',
      'Kenal konsep web dasar lewat block code HTML (halaman simple)',
    ],
    pricing: {
      promoMonthOnly: 1,
      basePriceValue: 250000,
      promoPriceValue: 200000,
      packages: [
        { id: 'PKG_4', sessions: 4, label: 'Paket 4 Sesi', default: true },
        { id: 'PKG_8', sessions: 8, label: 'Paket 8 Sesi' },
      ],
      note: 'Diskon hanya berlaku selama bulan Januari dan khusus pembelian paket.',
    },
    links: {
      checkoutBasePath: '/checkout',
      waLink: 'WHATSAPP_LINK_SD',
      preMeetingLink: '/book/premeeting?product=PRIVATE_SD',
    },
  },
  {
    slug: 'private-smp',
    title: 'Private Anak SMP',
    tagline: 'Belajar problem solving + web basic untuk anak SMP.',
    learnList: ['Block-based coding', 'Block code HTML (web basic)'],
    outcomeList: [
      'Paham logika & problem solving lebih terstruktur',
      'Bisa membuat mini project yang lebih kompleks dari level SD',
      'Bisa membuat website sederhana (landing page basic) lewat block code HTML',
    ],
    pricing: {
      promoMonthOnly: 1,
      basePriceValue: 250000,
      promoPriceValue: 200000,
      packages: [
        { id: 'PKG_4', sessions: 4, label: 'Paket 4 Sesi', default: true },
        { id: 'PKG_8', sessions: 8, label: 'Paket 8 Sesi' },
      ],
      note: 'Diskon hanya berlaku selama bulan Januari dan khusus pembelian paket.',
    },
    links: {
      checkoutBasePath: '/checkout',
      waLink: 'WHATSAPP_LINK_SMP',
      preMeetingLink: '/book/premeeting?product=PRIVATE_SMP',
    },
  },
];

export const getPrivateClassBySlug = (slug: string): ProductDetail | undefined =>
  PRIVATE_CLASS_DETAILS.find((item) => item.slug === slug);
